import React from "react";
import ArticleBooking from "../../components/ArticleBooking";
import PageContent from "../../components/Styles/PageContent";
import PageLayout from "../../components/Styles/PageLayout";

const ArticleBookingPage = () => {
  return (
    <PageLayout>
      <PageContent>
        <ArticleBooking />
      </PageContent>
    </PageLayout>
  );
};

export default ArticleBookingPage;
